export default function PHP_class() {
  return (
    <div>
      <h1>PHP_class</h1>
    </div>
  );
}
